module.exports = __webpack_public_path__ + "static/media/S-13-Y.47a17d99.mp3";